import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OwlDateTimeModule } from '../modules/picker/src/public_api';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouteFilterationComponent } from './component/route-filteration/route-filteration.component';
import { ItineriesRoutingModule } from './itineries-routing.module';
import { RouteListingComponent } from './component/route-listing/route-listing.component';
import { RouteDetailsComponent } from './component/route-details/route-details.component';
import { MainComponent } from './main.component';
import { HorizontalBarChartComponent } from './component/charts/horizontal-bar-chart/horizontal-bar-chart.component';
import { ChartsModule } from 'ng2-charts';
import { VerticalStackedBarChartComponent } from './component/charts/vertical-stacked-bar-chart/vertical-stacked-bar-chart.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgmCoreModule, LAZY_MAPS_API_CONFIG, LazyMapsAPILoaderConfigLiteral } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';
import { AgmOverlays } from 'agm-overlays';
import { RouteAllComponent } from './component/route-all/route-all.component';
import { SearchFilterComponent } from './component/search-filter/search-filter.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InfoModalComponent } from './modals/info-modal/info-modal.component';
import { I18nModule } from '../directives/i18n/i18n.module';


@NgModule({
  declarations: [
    RouteFilterationComponent,
    MainComponent,
    RouteListingComponent,
    RouteDetailsComponent,
    HorizontalBarChartComponent,
    VerticalStackedBarChartComponent,
    SearchFilterComponent,
    RouteAllComponent,
    InfoModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ItineriesRoutingModule,
    OwlDateTimeModule,
    ChartsModule,
    NgSelectModule,
    AgmCoreModule,
    AgmOverlays,
    AgmDirectionModule,
    DragDropModule,
    I18nModule
  ],
  exports: [RouteFilterationComponent, HorizontalBarChartComponent, VerticalStackedBarChartComponent,SearchFilterComponent, InfoModalComponent, RouteListingComponent]
})
export class ItineriesModule { }
